import {Component, inject} from '@angular/core';
import {MarkdownComponent} from "ngx-markdown";
import {MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle} from "@angular/material/expansion";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {ErrorHandlingService} from "../../../../services/error-handling.service";
import {FrequentlyAskedQuestionsService} from "../../../../services/frequently-asked-questions.service";
import {IFrequentlyAskedQuestions} from "../../../../interfaces/IFrequentlyAskedQuestions";
import {IGameQueryResult} from "../../../../interfaces/IGameQueryResult";
import {ChooseYourGameComponent} from "../../../../components/choose-your-game/choose-your-game.component";
import {UIStateEnum} from "../../../../enum/UIStateEnum";

@Component({
  selector: 'app-cross-game-admin-view-faqs',
  standalone: true,
  imports: [
    MarkdownComponent,
    MatAccordion,
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MatProgressSpinner,
    ChooseYourGameComponent
  ],
  templateUrl: './cross-game-admin-view-faqs.component.html',
  styleUrl: './cross-game-admin-view-faqs.component.css'
})
export class CrossGameAdminViewFaqsComponent {
  private errorHandlingService = inject(ErrorHandlingService);
  private frequentlyAskedQuestionsService = inject(FrequentlyAskedQuestionsService);

  public uiStateEnum = UIStateEnum;
  public uiState = UIStateEnum.ShowData;
  public faqs: IFrequentlyAskedQuestions[] = [];
  public chosenGame: IGameQueryResult | null = null;

  onGameChange(chosenGame: IGameQueryResult): void {
    this.chosenGame = chosenGame;
    if (this.chosenGame?.Id) {
      this.loadFaqsForGame(this.chosenGame.Id);
    }
  }

  private loadFaqsForGame(gameId: string): void {
    this.uiState = UIStateEnum.ShowLoading;
    this.frequentlyAskedQuestionsService.fetchAdminAppFaqs(gameId).subscribe({
      next: (res) => {
        this.faqs = res;
        this.uiState = UIStateEnum.ShowData;
      },
      error: (err) => {
        this.errorHandlingService.displayPageLevelErrorMessage(err);
        this.uiState = UIStateEnum.ShowData;
      },
    });
  }
}
